var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form-item',{attrs:{"label":_vm.label}},[_c('el-input',{attrs:{"type":_vm.type,"disabled":_vm.disabled},model:{value:(_vm.inpVal),callback:function ($$v) {_vm.inpVal=$$v},expression:"inpVal"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }